<template>
    <div v-if="Object.keys(samenvatting).length !== 0" class="animated fadeIn">

        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <i class="icon-cloud-download icons font-1xl"></i><strong> Weerstation</strong>
                        <small>
                            laatst gemeten waarden om {{datetimetoHHMM(samenvatting.weekterug.metingen[0].datetime_real)}}
                        </small>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-sm">
                            <thead>
                            <tr>
                                <th></th>
                                <template v-for="dag in samenvatting.weekterug.metingen">
                                    <th class="text-right">{{datetimetoDDMMYYYY(dag.datetime_real)}}</th>
                                </template>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Temperatuur (°C)</td>
                                <template v-for="dag in samenvatting.weekterug.metingen">
                                    <td class="text-right">{{komma1(dag.Temperatuur_gem)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Zonlicht (W/m²)</td>
                                <template v-for="dag in samenvatting.weekterug.metingen">
                                    <td class="text-right">{{komma0(dag.Zon_gem)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>PAR (µmol/m²s)</td>
                                <template v-for="dag in samenvatting.weekterug.metingen">
                                    <td class="text-right">{{komma0(dag.PAR_gem)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Relatieve vochtigheid (%)</td>
                                <template v-for="dag in samenvatting.weekterug.metingen">
                                    <td class="text-right">{{komma0(dag.RV_gem)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Neerslag (mm/dag)</td>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <td class="text-right">{{komma1(dag.somneerslag)}}</td>
                                </template>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </b-card>
            </div><!--/.col-->
        </div><!--/.row-->

        <div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <i class="icon-cloud-download icons font-1xl"></i><strong> Weerstation</strong>
                        <small>
                            dagwaarden
                        </small>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-sm">
                            <thead>
                            <tr>
                                <th></th>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <th class="text-right">{{dag.label}}</th>
                                </template>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Minimum temperatuur (°C)</td>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <td class="text-right">{{komma1(dag.mintemp)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Maximum temperatuur (°C)</td>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <td class="text-right">{{komma1(dag.maxtemp)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Zonlicht (MJ/m²)</td>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <td class="text-right">{{komma2(dag.somzonlicht)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>DLI (mol/m²)</td>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <td class="text-right">{{komma2(dag.somdli)}}</td>
                                </template>
                            </tr>
                            <tr>
                                <td>Neerslag (mm/dag)</td>
                                <template v-for="dag in samenvatting.weekterug.dagwaarden">
                                    <td class="text-right">{{komma1(dag.somneerslag)}}</td>
                                </template>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </b-card>
            </div><!--/.col-->
        </div><!--/.row-->

        <div class="row">
            <div class="col-sm-12">
                    <b-card>

                        <form>
                            <div class="row">

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="col-form-label" for="parameter">Parameter</label>
                                        <select @change="fillGraphData" type="text" name="parameter" id="parameter" v-model="currentFilter.parameter" class="form-control">
                                            <template v-for="parameter in parameters">
                                                <option :value="parameter.id" :selected="parameter.id == currentFilter.parameter">{{parameter.name}}</option>
                                            </template>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="col-form-label" for="begindatum">Van</label>

                                        <datepicker @input="changeFromDate()"
                                                    :highlighted="highlighted"
                                                    :disabled-dates="disabledDates"
                                                    :required="true"
                                                    v-model="currentFilter.datumVan"
                                                    :bootstrapStyling="true"
                                                    :full-month-name="true"
                                                    :language="nl"
                                                    :monday-first="true"
                                                    name="begindatum"
                                                    id="begindatum"
                                                    ref="begindatum"
                                                    format="d MMMM yyyy"
                                                    minimumView="day"
                                                    maximumView="year"
                                                    initialView="day"></datepicker>

                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label class="col-form-label" for="einddatum">Tot</label>
                                        <datepicker @input="changeToDate()" :highlighted="highlighted" :disabled-dates="disabledDates" :required="true" v-model="currentFilter.datumTot" :bootstrapStyling="true" style="background-color : #ffffff;" :full-month-name="true" :language="nl" :monday-first="true" name="einddatum" id="einddatum" ref="einddatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                    </div>
                                </div>

                            </div>
                        </form>


                        <div class="row">

                            <div class="col-sm-12">

                                <div v-if="showgrafiek">
                                    <br />

                                    <span class="small text-muted">{{eenheid}}</span>

                                    <div v-if="grafiektype == 0">
                                        <chart0 :chart-data="datacollection" class="chart-wrapper" style="height:300px;margin-top:40px;"></chart0>
                                    </div>
                                    <div v-if="grafiektype == 1">
                                        <chart1 :chart-data="datacollection" class="chart-wrapper" style="height:300px;margin-top:40px;"></chart1>
                                    </div>
                                    <div v-if="grafiektype == 2 && currentFilter.parameter == 4">
                                        <chart2b :chart-data="datacollection" class="chart-wrapper" style="height:300px;margin-top:40px;"></chart2b>
                                    </div>
                                    <div v-if="grafiektype == 2 && currentFilter.parameter != 4">
                                        <chart2 :chart-data="datacollection" class="chart-wrapper" style="height:300px;margin-top:40px;"></chart2>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </b-card>
            </div><!--/.col-->
        </div><!--/.row-->

    </div>
</template>

<script>
    // van weerstation APP
    // aangepast: paden van imports, extra functies in datefunctions, watermerk weg
    // download sectie weg, opmaak gewijzigd

    import api from '../../api/weerstation/weerstation';
    import Datepicker from 'vuejs-datepicker';
    import { nl } from 'vuejs-datepicker/dist/locale';
    import datefunctions from '../../helpers/datefunctions';

    import Chart0 from './LineChartR0';
    import Chart1 from './LineChartR1';
    import Chart2 from './LineChartR2';
    import Chart2b from './BarChartR2';

    export default {
        data () {
            return {
                nl,
                showeerstetabel: true,
                showgrafiek: false,
                dataaanvraagok: false,
                grafiektype: 0,
                parametertekst: '',
                eenheid: '',
                waardetekst: '',
                intervaltekst: '',
                aantaldagen: 0,
                parameters: [ { 'id': 0,
                                'field' : 'Temperatuur',
                                'name': 'Temperatuur' },
                  { 'id': 2,
                    'field' : 'Zon',
                    'name': 'Zonlicht' },
                  { 'id': 1,
                    'field' : 'PAR',
                    'name': 'PAR' },
                  { 'id': 3,
                    'field' : 'RV',
                    'name': 'Relatieve vochtigheid' },
                  { 'id': 4,
                    'field' : 'Neerslag',
                    'name': 'Neerslag' },
                  ],
                samenvatting: {},
                currentFilter: {
                    parameter: 0,
                    datumVan: new Date(),
                    datumTot: new Date(),
                },
                downloadFilter: {
                    naam: '',
                    voornaam: '',
                    email: '',
                    datum_van: new Date(),
                    datum_tot: new Date(),
                },
                disabledDates: {
                  to: new Date(),
                  from: new Date(),
                },
                highlighted: {
                  dates: [ // highlight current date
                    new Date(),
                  ],
                },
                datacollection: {
                  labels: [''],
                  datasets: [
                    {
                      label: '',
                      data: [10],
                    },
                  ],
                },
            };
        },
        created () {
            api.getHomepageTable().then((response) => {
              this.samenvatting = response.data;
              this.disabledDates.to = new Date(this.samenvatting.interval.datumVan);
              this.disabledDates.to.setDate(this.disabledDates.to.getDate()-1);
              this.disabledDates.from = new Date(this.samenvatting.interval.datumTot);
              this.disabledDates.from.setDate(this.disabledDates.from.getDate()+1);
              this.fillGraphData();
            });
        },
        methods: {
            datetimetoHHMM (datetime) {
                return datefunctions.datetimetoHHMM(datetime);
            },
            datetimetoDDMMYYYY (datetime) {
                return datefunctions.datetimetoDDMMYYYY(datetime);
            },
            changeFromDate() {
                if (this.currentFilter.datumVan > this.currentFilter.datumTot) {
                    let nieuweTot = this.addDays(this.currentFilter.datumVan, this.aantaldagen);
                    if (nieuweTot > this.disabledDates.from) {
                      this.currentFilter.datumTot = this.addDays(this.disabledDates.from, - 1);
                    } else {
                      this.currentFilter.datumTot = nieuweTot;
                    }
                }
                this.aantaldagen = this.daysdiff(this.currentFilter.datumVan, this.currentFilter.datumTot);
                this.fillGraphData();
            },
            changeToDate() {
                if (this.currentFilter.datumTot < this.currentFilter.datumVan) {
                    let nieuweVan = this.addDays(this.currentFilter.datumTot, - this.aantaldagen);
                    if (nieuweVan < this.disabledDates.to) {
                        this.currentFilter.datumVan = new Date(this.disabledDates.to);
                    } else {
                        this.currentFilter.datumVan = nieuweVan;
                    }
                }
                this.aantaldagen = this.daysdiff(this.currentFilter.datumVan, this.currentFilter.datumTot);
                this.fillGraphData();
            },
            addDays(date, days) {
                var result = new Date(date);
                result.setDate(result.getDate() + days);
                return result;
            },
            daysdiff(date1, date2) {
              var timeDiff = Math.abs(date2 - date1);
              var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
              return diffDays;
            },
            addDownload() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        api.addDownload(this.downloadFilter).then(() => {
                            this.dataaanvraagok = true;
                            var self = this;
                            setTimeout(function(){ self.dataaanvraagok = false; }, 10000);
                        },
                        (error) => {
                            console.log(error.message);
                        });
                    }
                });
            },
            fillGraphData() {
                api.getValues(this.currentFilter.parameter,
                    this.currentFilter.datumVan, this.currentFilter.datumTot).then((response) => {
                    this.showgrafiek = true;
                    this.grafiektype = response.data.grafiektype;
                    this.intervaltekst = response.data.intervaltekst;
                    this.parametertekst = response.data.parameter;
                    this.waardetekst = response.data.waarde;
                    this.eenheid = response.data.eenheid;
                    const labels = [];
                    const data = [];

                    this.formatresults(response.data.waarden, labels, data);
                    this.fillData(this.waardetekst, labels, data);

                    // alleen voor temperatuur en grafiektype 2
                    if ((this.grafiektype == 2) && (this.currentFilter.parameter == 0)) {
                        const dataMin = [];
                        const dataMax = [];
                        this.formatMinMaxresults(response.data.waarden, dataMin, dataMax);
                        this.AddMinMaxData(dataMin, dataMax);
                    }

                  // alleen voor neerslag en grafiektype 2
                  if ((this.grafiektype == 2) && (this.currentFilter.parameter == 4)) {
                    this.datacollection.datasets[0].backgroundColor = 'rgba(0, 204, 204, 0.2)';
                  }
                });
            },
            formatMinMaxresults (reponsedata, dataMin, dataMax) {
                reponsedata.forEach((rdata) => {
                    dataMin.push(rdata.minwaarde); // hier nog de waarden min en max pakken!
                    dataMax.push(rdata.maxwaarde);
                });
            },
            formatresults (reponsedata, labels, data) {
                reponsedata.forEach((rdata) => {
                    labels.push(rdata.label);
                    data.push(rdata.waarde);
                });
            },
            fillData (label, labels, data) {
                this.datacollection = {
                    labels,
                    datasets: [
                        {
                            label,
                            backgroundColor: 'rgba(0, 204, 204, 0)',
                            borderColor: 'rgba(0, 204, 204, 1)',
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data,
                        }
                    ],
                };
            },
            AddMinMaxData (dataMin, dataMax) {
                  this.datacollection.datasets.push({
                      label: 'minimum',
                      backgroundColor: 'rgba(255, 128, 0, 0)',
                      borderColor: 'rgba(255, 128, 0, 1)',
                      pointHoverBackgroundColor: '#fff',
                      borderWidth: 2,
                      data: dataMin,
                  });
                  this.datacollection.datasets.unshift({
                      label: 'maximum',
                      backgroundColor: 'rgba(255,20,147, 0)',
                      borderColor: 'rgba(255,20,147, 1)',
                      pointHoverBackgroundColor: '#fff',
                      borderWidth: 2,
                      data: dataMax,
                  });
            },
            komma2 (waarde) {
                if (waarde == null) {
                    return '#.##';
                }
                return waarde.toFixed(2);
            },
            komma1 (waarde) {
                if (waarde == null) {
                    return '#.#';
                }
                return waarde.toFixed(1);
            },
            komma0 (waarde) {
                if (waarde == null) {
                    return '#';
                }
                return waarde.toFixed(0);
            },
        },
        components: {
          datepicker: Datepicker,
          chart0: Chart0,
          chart1: Chart1,
          chart2: Chart2,
          chart2b: Chart2b,
        },
    };
</script>

<style>

    th{
        font-weight: normal;
        font-style: italic;
    }

</style>



// WEBPACK FOOTER //
// src/pages/weerstation/Homepage.vue